import useIntlMessage from '@pe-libs/react-components/build/lib/intl/hooks/useIntlMessage';
import React, { FC } from 'react';
import useRedirect from '#hooks/useRedirect';
import Link from '#modules/expertDirectory/components/Link';
import DataLinks from './Helper';
import Logo from './Logo';
import messages from './messages';
import useStyles from './styles';

type Props = {
  provenemployer?: boolean;
};

type Links = Array<{
  label: string;
  href: string;
}>;

const Footer: FC<Props> = ({ provenemployer }) => {
  const styles = useStyles();
  const formatMessage = useIntlMessage();
  const { urlToLivePage } = useRedirect();

  const links: Links = DataLinks(formatMessage, urlToLivePage, provenemployer);

  return (
    <footer className={styles.footer}>
      <div className={styles.footerContainer}>
        <div className={styles.copyright}>
          <Logo isProvenEmployer={provenemployer} />
          {formatMessage(messages.copyright, { currentYear: new Date().getFullYear() })}
        </div>
        <ul className={styles.links}>
          {links.map((link) => (
            <li key={link.label}>
              <Link href={link.href} currentColor={true}>
                {link.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </footer>
  );
};

export default Footer;
